var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNepal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "nepal_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#nepal_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CE0000",
  stroke: "#000063",
  strokeWidth: 1.194,
  d: "M.304 23.695H18.06L6.44 11.911l12.06.014L.309.305v23.39z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.47 17.428-1.266.422.993.928-1.335-.084.548 1.228-1.195-.577.023 1.34-.881-.979-.502 1.247-.431-1.233-.952.966.085-1.299-1.261.535.59-1.172-1.373.028 1.008-.858-1.28-.492 1.266-.422-.999-.928 1.332.085-.544-1.229 1.2.577-.024-1.34.882.979.501-1.247.427 1.233.956-.966-.089 1.299 1.266-.535-.596 1.172 1.378-.028-1.007.858zM6.95 8.77l-.53.394.263.216a4.4 4.4 0 0 0 1.44-1.688c.084.999-.83 3.235-3.22 3.258A3.31 3.31 0 0 1 1.55 7.655c.468.853.759 1.265 1.5 1.71l.22-.206-.497-.417.642-.169-.347-.58.675.046-.084-.675.59.347.188-.633.422.506.398-.482.216.656.553-.385-.07.67.665-.079-.314.619z"
}))));
export default SvgNepal;